export default {
    linkList : {
        "operationPolicy": "Operation Policy",
        "communityPolicy": "Community Policy",
        "youthProtectionPolicy": "Youth Protection Policy",
        "declarationOfSafety": "Security・Safety Declaration",
        "cookiePolicy": "Cookie Policy",
        "customerSupport": "SUPPORT",
        "guaranteeOfRights": "Rights of the Data Subject",
        "privacyPolicy": "Privacy Policy",
        "termsOfService": "Terms of Use",
        "companyLink": "About Us",
        "doNotSell": "Do Not Sell My Personal Information",
        "gameGrade": "게임이용등급",
        "communityPolicyView": "커뮤니티정책",
        "servicePolicy": "서비스정책",
        "termsOfUse": "회원정책",
        "operationPolicyNCJ": "운영방침",
    },
    footerWords:{
        "gameRelatedLaw": "Additional Information Following Gaming Laws",
        "brandInformation": "Company Name Information",
        "copyright": "Copyright",
        "channelingInfo": "NCSOFT is a broker who mediates mail order sales of channeling games within plaync, and is not a sales party of the aforementioned sales.<br>All obligations and responsibilities associated with the provided channeling games lay with the individual mail order sales party, and we are not responsible for issues regarding them."
    },
    infoCS:{
        "businessInformation": "View Business Information",
        "infoAddress": "Company Name: NCSOFT Corporation, CEO: Kim Taek-Jin, Business Registration Number: 144-85-04244, E-commerce Registration: 2013-Gyeonggi Seongnam-1268",
        "mobile": "Address: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea. Customer SUPPORT: +82 1566-7004. Fax: +82 02-2186-3499.",
        "pc": "",
        "other": "Address: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea. Customer SUPPORT: +82 1600-0020 (PC Game), +82 1566-7004 (Mobile Game). Fax: +82 02-2186-3550 (PC Game), +82 02-2186-3499 (Mobile Game).",
        "none": '',
        "infoEmail": "E-mail",
        
        "infoEmail-mobile": "MobileCS@ncsoft.com",
        "infoEmail-pc": "credit@ncsoft.com",
        "infoEmail-other": "credit@ncsoft.com/(PC Game)/MobileCS@ncsoft.com/(Mobile Game)",
        "infoEmail-none": "",
    },
    infoJP:{
        "jpReleaseDayValue_LW": "04 Novemver 2021",
        "jpReleaseDay": "Release Date",
        "jpDevelopedBy": "Developer/Publisher",
        "jpOs": "Supported OS",
        "jpPriceValue": "Free to Play (Contains in-app purchases)",
        "jpPrice": "Price",
        "jpGenre": "Genre",
        "jpTitle": "Title",
    },
    "country": {
        "HK": "Hong Kong",
        "PH": "Philippines",
        "TH": "Thailand",
        "QA": "Qatar",
        "JP": "Japan",
        "ID": "Indonesia",
        "AE": "United Arab Emirates",
        "SG": "Singapore",
        "SA": "Saudi Arabia",
        "MY": "Malaysia",
        "RU": "Russia",
        "TW": "Taiwan",
        "KR": "Republic of Korea",
        "UA": "Ukraine",
        "BY": "Belarus",
        "LT": "Lithuania",
        "PL": "Poland",
        "GR": "Greece",
        "IL": "Israel",
        "KW": "Kuwait",
        "AT": "Austria",
        "US": "United States of America",
        "CA": "Canada",
        "DE": "Germany",
        "GB": "United Kingdom",
        "FR": "France",
        "BR": "Brazil",
        "IT": "Italy",
        "ES": "Spain",
        "CL": "Chile",
        "NO": "Norway",
        "SE": "Sweden",
        "IE": "Ireland",
        "PT": "Portugal",
        "FI": "Finland",
        "DK": "Denmark",
        "CH": "Switzerland",
        "AR": "Argentina",
        "PE": "Peru",
        "MX": "Mexico",
        "KZ": "Kazakhstan",
        "UZ": "Uzbekistan",
        "AZ": "Azerbaijan",
        "GE": "Georgia",
        "MD": "Moldova",
        "AM": "Armenia",
        "NC": "Global"
    }
};